import { Alert, Box, Button, Link, Snackbar, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { AuthContainer } from './style';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingButton from '@mui/lab/LoadingButton';
import logo from '../../assets/logo/Logo.svg';
import logo360 from '../../assets/logo/PRIME36oBlueLogo.svg';

function EmailOtpPage() {
    const [otp, setOtp] = useState('');
    const { answer, user, isAuthenticated, passwordLessLogin } = useAuth();
    const theme = useTheme();
    const [openToster, setOpenToster] = useState(false);
    const [tosterVariant, setTosterVariant] = useState('error');
    const [tosterMessage, setTosterMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    if (!location.state) {
        navigate('/login', {
            replace: true,
        });
    }

    const handleResend = async () => {
        passwordLessLogin({
            email: location.state?.email?.trim(),
            callback: (failed) => {
                if (failed) {
                    setTosterVariant('error');
                    setTosterMessage(failed ? failed : `Sorry, we don't recognize this email address`);
                    setOpenToster(true);
                }
                setLoading(false);
            },
        });
        setTimeout(() => {
            setTosterVariant('success');
            setTosterMessage('Resent code successfully');
            setOpenToster(true);
        }, 1000);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        let authenticated = await isAuthenticated();
        if (authenticated) {
            window.location.href = '/';
            return;
        }
        if (otp) {
            answer(user, otp, (message) => {
                message = message ? message : 'Invalid otp';
                if (message) {
                    setTosterVariant('error');
                    setTosterMessage(message);
                    setOpenToster(true);
                }
                setLoading(false);
                setOtp('');
            });
        }
    };

    const handleChange = (newValue) => {
        setOtp(newValue);
    };

    const handleTosterClose = () => {
        setOpenToster(false);
    };

    return (
        <AuthContainer>
            <Box
                display={'flex'}
                flexDirection={'column'}
                sx={{
                    wordBreak: 'break-word',
                }}
            >
                <Box display="flex" justifyContent="center">
                    {window.location.hostname?.startsWith('tax.') ? <img src={logo} height={40} width={120} alt="Logo" /> : <img src={logo360} height={40} width={120} alt="Logo" />}
                </Box>
                <Typography
                    component={'h1'}
                    variant="heading1"
                    color={'text.primary'}
                    fontSize={{
                        xs: theme.typography.customFontSize.xxxLarge,
                        sm: theme.typography.customFontSize.verylarge,
                    }}
                    // fontWeight={theme.typography.fontWeightBold}
                    textAlign={{
                        xs: 'center',
                    }}
                    fontFamily='"Barlow Condensed", sans-serif'
                    marginTop={{
                        xs: theme.typography.generic.large,
                    }}
                >
                    Enter your verification code
                </Typography>
                <Typography
                    component={'p'}
                    color={'text.secondary'}
                    variant="subHeading"
                    // color={theme.palette.text.secondary}
                    fontSize={{
                        xs: theme.typography.customFontSize.medium,
                        sm: theme.typography.customFontSize.large,
                    }}
                    // fontWeight={theme.typography.fontWeightSemiBold}
                    textAlign={{
                        xs: 'center',
                    }}
                    marginTop={{
                        xs: theme.typography.generic.medium,
                    }}
                >
                    We have sent a 6-digit verification code to <strong> {location.state?.email}</strong>
                </Typography>
            </Box>

            <Box component="form" onSubmit={handleSubmit} display={'flex'} flexDirection={'column'} width={'100%'} justifyContent={'center'} alignItems={'center'}>
                <MuiOtpInput
                    width={{
                        xs: '100%',
                        sm: '100%',
                        md: '95%',
                        lg: '80%',
                    }}
                    type="number"
                    autoFocus
                    overflow={{
                        xs: 'auto',
                    }}
                    paddingBottom={'0.5rem'}
                    value={otp}
                    length={6}
                    onChange={handleChange}
                    sx={{
                        gap: 'unset',
                        overflow: 'unset',

                        '&>*': {
                            marginRight: { xs: '2px !important', sm: '1rem !important' },
                        },
                        '&>*:last-child': {
                            marginRight: { xs: '0 !important' },
                        },

                        '& .MuiInputBase-input': {
                            padding: {
                                xs: '14px 2px',
                                sm: '16px 14px',
                            },
                        },

                        [theme.breakpoints.down('sm')]: {
                            overflow: 'auto',
                        },
                    }}
                    TextFieldsProps={(index) => ({
                        inputProps: {
                            'aria-label': `otp text field ${index + 1}`,
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                        },
                        sx: {
                            minWidth: '2.5rem',
                        },
                        type: 'number',
                    })}
                />
                <LoadingButton loading={loading} type="submit" fullWidth variant="contained" size="large" sx={{ mt: '1rem' }}>
                    Verify and proceed
                </LoadingButton>
            </Box>
            {window.location.hostname?.startsWith('tax.') && (
                <Typography
                    component={'p'}
                    color={'text.secondary'}
                    fontSize={'13px'}
                    textAlign={{
                        xs: 'center',
                    }}
                    marginTop={{
                        xs: 0,
                    }}
                    // lineHeight='140%'
                >
                    For questions or support related to this assessment or your tax plan, please contact us at <br></br>
                    <a style={{ color: '#00297A' }} href="mailto:decoder@primecorporateservices.com">
                        decoder@primecorporateservices.com
                    </a>
                </Typography>
            )}

            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} width={'100%'}>
                <Typography
                    component={'p'}
                    color={'text.secondary'}
                    variant="subHeading"
                    fontSize={{
                        xs: theme.typography.customFontSize.medium,
                        sm: theme.typography.customFontSize.large,
                    }}
                    textAlign={{
                        xs: 'center',
                    }}
                >
                    Didn’t receive a login code?
                </Typography>

                <Link
                    tabIndex={0}
                    onClick={handleResend}
                    // component={Button}
                    sx={{
                        fontWeight: theme.typography.fontWeightSemiBold,
                        fontSize: theme.typography.customFontSize.large,
                        lineHeight: '1.5',
                        cursor: 'pointer',
                        textDecoration: 'none',
                    }}
                >
                    Resend code
                </Link>
            </Box>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openToster} autoHideDuration={6000} onClose={handleTosterClose}>
                <Alert onClose={handleTosterClose} severity={tosterVariant} variant="filled">
                    {tosterMessage}
                </Alert>
            </Snackbar>
        </AuthContainer>
    );
}

export default EmailOtpPage;
